import React, { useState } from 'react';
import { Play } from 'lucide-react';

/** Holds back the video file until someone actually asks for it. Nothing is downloaded,
 *  decoded or autoplayed on first load, which is where the homepage was spending its time. */
export const LazyVideo = ({ src, className = '', testId, label = 'Play video' }) => {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <video
        src={src}
        autoPlay
        loop
        muted
        playsInline
        controls
        preload="metadata"
        className={`${className} aspect-video bg-slate-950`}
        data-testid={testId}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setPlaying(true)}
      aria-label={label}
      data-testid={`${testId}-poster`}
      className={`${className} group relative flex aspect-video w-full items-center justify-center overflow-hidden bg-slate-950 ring-1 ring-white/10 transition-shadow hover:shadow-2xl`}
    >
      <span
        className="pointer-events-none absolute inset-0 opacity-70"
        style={{ background: 'radial-gradient(120% 90% at 50% 0%, #1e3a8a 0%, #0b1220 60%, #050a16 100%)' }}
        aria-hidden="true"
      />
      <span className="relative flex flex-col items-center gap-3 px-6 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-blue-600 shadow-lg transition-transform group-hover:scale-105">
          <Play className="ml-0.5 h-6 w-6 text-white" fill="currentColor" />
        </span>
        <span className="text-sm font-medium text-white">Watch it read the detail</span>
        <span className="text-xs text-slate-400">Tap to play — nothing downloads until you do</span>
      </span>
    </button>
  );
};

export default LazyVideo;
